import React, { useEffect, useState } from 'react';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';
import { getService } from '@Client/runner.hooks/useService';
import { Guid } from '@Shared.Angular/@types/guid';

type Props = {
  id: Guid;
  title: string;
  name: string;
  hasTagInUse: boolean;
  deleteSuccess: () => void;
  closeModal: () => void;
};

export const TagGroupDeleteModal = (props: Props) => {
  const { title, name, id, hasTagInUse, deleteSuccess, closeModal } = props;
  const deleteConfirmationText = 'delete';
  const [deleteText, setDeleteText] = useState('');
  const [deleteButtonEnabled, setDeleteButtonEnabledStatus] = useState(false);

  useEffect(() => {
    setDeleteButtonStatus();
  }, [deleteText, hasTagInUse]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDeleteText(event.target.value);
  };

  const setDeleteButtonStatus = () => {
    if (hasTagInUse) {
      setDeleteButtonEnabledStatus(false);
      return;
    }
    if (deleteText.toLowerCase() !== deleteConfirmationText) {
      setDeleteButtonEnabledStatus(false);
      return;
    }
    setDeleteButtonEnabledStatus(true);
  };

  const categoryApiService = getService('tagGroupApiService');

  const notificationService = getService('notificationService');

  const appInsightsService = getService('appInsightsService');

  const deleteTagGroup = async () => {
    appInsightsService.startEventTimer('setupTaggroupsDeleted');
    try {
      await categoryApiService.delete(id);
      deleteSuccess();
      notificationService.showSuccessToast('Tag Group deleted successfully');
    } catch (error) {
      console.error(error);
      notificationService.showErrorToast(error.data.message);
    }
  };

  return (
    <Modal
      id="tag-group-delete-modal"
      title={title}
      onClose={closeModal}
      onCancelClick={closeModal}
      onActionClick={deleteTagGroup}
      actionButtonText="Delete Tag Group"
      actionButtonType="danger"
      isActionDisabled={!deleteButtonEnabled}
      size="md"
    >
      <fieldset className="setup-tag-groups-delete-modal-fieldset">
        <legend className="setup-tag-groups-delete-modal-legend">
          <b>Warning</b>
        </legend>
        <div className="tag-group-delete-name">
          You are about to delete <b>{name}</b>.
        </div>
        <div>This cannot be undone!</div>
        <br />

        <div className="delete-warnings-container">
          {hasTagInUse ? (
            <span>
              <i
                className="fa-light fa-triangle-exclamation setup-tag-groups-delete-modal-warning-icon"
                aria-hidden="true"
              ></i>
              &nbsp; You cannot delete this Tag Group because one or more of its
              tags are currently in use. Remove the tags from all associated
              flow models to enable deletion.
            </span>
          ) : (
            ''
          )}
        </div>
        {!hasTagInUse && (
          <>
            <div>
              Type <b>DELETE</b> to continue
            </div>
            <input
              id="delete-modal"
              className="setup-tag-groups-delete-modal-textfield"
              type="text"
              value={deleteText}
              onChange={handleInputChange}
              data-testid="tag-group-delete-confirmation-input"
            />
          </>
        )}
      </fieldset>
    </Modal>
  );
};
